import {
  FarmerRepository,
  FarmerRepositoryImpl,
} from "@/features/farmer/data/repositories/farmer-repositories";
import { Profile } from "@/features/farmer/domain/farmer-interface";

export async function farmerProfileService(farmerId: string) {
  const farmerRepository: FarmerRepository = new FarmerRepositoryImpl();

  const response: Profile | undefined = await farmerRepository._getProfile(
    farmerId
  );

  if (response?.farmer) {
    localStorage.setItem(
      "profile",
      JSON.stringify({
        ...response.farmer,
        access: response.access,
      })
    );
  }

  return response;
}

export async function farmerLogoutService() {
  const farmerRepository: FarmerRepository = new FarmerRepositoryImpl();

  const response: string | undefined = await farmerRepository._logout();

  if (response) {
    localStorage.removeItem("profile");
    localStorage.removeItem("isExpert");
    localStorage.removeItem("expertId");
    window.location.reload();
  }

  return response;
}
